import React from 'react';
import WorkforceLaborGrid from './WorkforceLaborGrid';

export default function WorkforceLabor() {
  return <WorkforceLaborGrid />;
}
